import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import CustomModal from "./CustomModal";
import { sentNewsletter } from "../api/api";

const STORAGE_KEY = "ss_newsletter_modal_seen";
const SHOW_DELAY_MS = 1500;

const NewsletterSignupModal = () => {
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let alreadySeen = false;
    try {
      alreadySeen = localStorage.getItem(STORAGE_KEY) === "1";
    } catch {
      // localStorage unavailable (private browsing, disabled storage) -
      // just don't show the modal rather than risk showing it every load.
      alreadySeen = true;
    }
    if (alreadySeen) return;

    const timer = setTimeout(() => setShow(true), SHOW_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  const dismiss = () => {
    setShow(false);
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      // ignore - worst case the modal reappears next visit
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await sentNewsletter({ email });
      if (response?.message) {
        toast.success("You're subscribed! Keep an eye on your inbox.");
        setEmail("");
        dismiss();
      } else {
        toast.error(response?.error?.message || "Failed to subscribe. Please try again.");
      }
    } catch (err) {
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <CustomModal show={show} onClose={dismiss} title="Stay in the loop" height>
      <div className="w-full flex flex-col gap-4 pt-4">
        <p className="text-16 text-navy text-left max-w-prose">
          Connection is one conversation away. Get resources, events, and stories
          from families who understand.
        </p>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            required
            className="input-brand text-16 w-full"
          />
          <button
            type="submit"
            disabled={loading}
            className="btn-primary disabled:opacity-60"
          >
            {loading ? "Submitting..." : "Keep me updated"}
          </button>
        </form>
      </div>
    </CustomModal>
  );
};

export default NewsletterSignupModal;
